var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00b538;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.47,32.45h-.29c-.52-.24-.6-.6-.47-1.15l2.41-9.7h-6.71c-.48,0-.76-.52-.62-.96l4.85-12.55c.12-.31.4-.55.74-.55h6.7c.2,0,.5.23.59.37.09.15.1.5.01.7l-2.87,6.51h5.68c.27,0,.62.23.7.43.09.23.05.52-.11.77l-10.18,15.85-.44.27ZM25.78,17.29c.17-.26.35-.39.42-.7l-5.47-.02c-.21,0-.54-.19-.64-.33-.11-.16-.1-.52-.01-.73l2.87-6.51h-5.12s-4.33,11.17-4.33,11.17h6.59c.43,0,.7.43.66.81l-1.62,6.61,2.21-3.41,4.43-6.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarter);
export default __webpack_public_path__ + "static/media/starter.bde34a3685adf3aaa43914a7d52c44ac.svg";
export { ForwardRef as ReactComponent };